export default __webpack_public_path__ + "static/media/Papi-Chulo.18b631e6.gif";